import { render, staticRenderFns } from "./VerticalPurchased.vue?vue&type=template&id=6bb45e79"
import script from "./VerticalPurchased.vue?vue&type=script&lang=js"
export * from "./VerticalPurchased.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports